import classnames from "classnames";
import { isNotEmpty, isPresent, noop } from "neetocist";
import { Typography } from "neetoui";
import { omit } from "ramda";
import { useTranslation } from "react-i18next";

import Container from "components/Container";

import ExpiryNotice from "./ExpiryNotice";
import LinkBlock from "./Link";
import ShareBlock from "./ShareBlock";

const MainPanel = ({
  title,
  description,
  qrCodeProps,
  socialMediaProps,
  isLoading = false,
  enabledOptions = { regenerate: false, edit: false },
  urls = [],
  entity,
  entityName,
  handleEdit = noop,
  handleRegenerate = noop,
  moreOptions,
  disableShareSocialMedia = false,
  disableQRDownload = false,
  publicLinkExpiryConfiguration = {},
  customTopContent,
  customBottomContent,
}) => {
  const { t } = useTranslation();

  const shouldShowShareBlock =
    !disableQRDownload || !disableShareSocialMedia || isPresent(moreOptions);

  return (
    <Container className="neeto-ui-bg-gray-100 neeto-molecule-share-landing-page">
      <div className="mx-auto w-full max-w-5xl py-10">
        {customTopContent}
        <Typography
          data-testid="share-your-meeting-heading"
          lineHeight="tight"
          style="h2"
          className={classnames({
            "mb-2": isPresent(description),
            "mb-6": !isPresent(description),
          })}
        >
          {title ||
            t("neetoMolecules.shareViaLink.title", {
              productName: globalProps.appName,
            })}
        </Typography>
        {description && (
          <Typography
            className="mb-6"
            data-testid="share-your-meeting-heading"
            lineHeight="normal"
            style="body1"
          >
            {description}
          </Typography>
        )}
        <div
          className="neeto-ui-rounded-lg neeto-ui-bg-white p-6 sm:p-8"
          data-testid="share-via-link"
        >
          {isNotEmpty(urls) && (
            <div className="flex flex-col gap-y-1">
              <div className="inline-flex max-w-full flex-col gap-y-4">
                {urls?.map(urlOption => (
                  <LinkBlock
                    {...{
                      enabledOptions,
                      entityName,
                      handleEdit,
                      handleRegenerate,
                      isLoading,
                    }}
                    editUrlProps={omit(["url"], urlOption)}
                    key={urlOption.url}
                    previewUrl={urlOption.previewUrl}
                    url={urlOption.url}
                  />
                ))}
              </div>
              {isPresent(publicLinkExpiryConfiguration) && (
                <ExpiryNotice
                  expiryConfiguration={publicLinkExpiryConfiguration}
                />
              )}
            </div>
          )}
          {shouldShowShareBlock && (
            <ShareBlock
              {...{
                disableQRDownload,
                disableShareSocialMedia,
                entity,
                moreOptions,
                qrCodeProps,
                socialMediaProps,
                urls,
              }}
              url={urls[0]?.url}
            />
          )}
        </div>
        {customBottomContent}
      </div>
    </Container>
  );
};

export default MainPanel;
